import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=f6a7f58c&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=ts"
export * from "./ServiceItem.vue?vue&type=script&lang=ts"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=f6a7f58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a7f58c",
  null
  
)

export default component.exports